export default __webpack_public_path__ + "18ca04b20314a3e6c8216aa2bdd3c082.png";